import React from "react";
import facilities1 from "../../images/home/facilityIcon1.png";
import facilities2 from "../../images/home/facilityIcon2.png";
import facilities3 from "../../images/home/facilityIcon3.png";
import facilities4 from "../../images/home/facilityIcon4.png";
import facilities5 from "../../images/home/facilityIcon5.png";
import facilities6 from "../../images/home/facilityIcon6.png";
import facilities7 from "../../images/home/facilityIcon7.png";
import facilities8 from "../../images/home/facilityIcon8.png";
import facilities9 from "../../images/home/facilityIcon9.png";
import facilities10 from "../../images/home/facilityIcon10.png";
import facilities11 from "../../images/home/facilityIcon11.png";
import facilities12 from "../../images/home/facilityIcon12.png";

const RoomFacility = () => {
  const facilities = [
    { icon: facilities11, title: "Daily Housekeeping" },
    { icon: facilities5, title: "King-Size Bedrooms" },
    { icon: facilities4, title: "Lavish Bathrooms" },
    { icon: facilities2, title: "Jacuzzi" },
    { icon: facilities9, title: "Infinity Pool" },
    { icon: facilities6, title: "Outdoor Dining Area" },
    { icon: facilities7, title: "Air-Conditioning" },
    { icon: facilities8, title: "Sound System" },
    { icon: facilities3, title: "Power Backup" },
    { icon: facilities10, title: "Home-cooked Meals" },
    { icon: facilities1, title: "Local Guide" },
    { icon: facilities12, title: "Wi-Fi" },
  ];

  return (
    <div
      className="mb-20 max-md:mt-16 max-md:px-4"
      style={{ marginTop: "150px" }}
    >
      <div
        className="relative text-white py-12 mt-10 mb-10 border border-[#DACEB5] rounded-[30px]  mx-10 shadow-lg "
        style={{ maxWidth: "1440px", margin: "auto" }}
      >
        {/* Top border styling */}
        <div className="absolute -top-10 left-1/2 transform -translate-x-1/2 bg-white px-6 py-1 rounded-md">
          <h2 className="text-[46px]   text-[#672220] font-bold">Amenities</h2>
        </div>

        <p className="text-[#585858] text-lg poppins-medium text-center mb-8">
          You Should Expect
        </p>
        {/* Facilities Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-10  mx-auto ">
          {facilities.map((facility, index) => (
            <div key={index} className="flex flex-col items-center text-center">
              <img
                src={facility.icon}
                alt={facility.title}
                className="w-16 h-16"
              />
              <p className="mt-2 text-[#585858] poppins-light text-[11px] md:text-[14.84px]">
                {facility.title}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default RoomFacility;
